import {
    Mesh,
    MeshPhongMaterial,
    Color,
    NoBlending,
    Quaternion,
    Vector3
} from 'three';

import { CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
import { VRObject3D } from './VRObject3D';
import { youtubePlaneGeometry } from './helpers/texturesAndGeometries';

class VRIframeAgentGhost extends VRObject3D {

    iframe_value = null;

    constructor(containerName, camera, iframeValue, x, y, z, model) {

        super(containerName);
        this.camera = camera;
        this.iframe_value = iframeValue || '';
        this.limits = {
            min: 280,
            max: 800,
            distance: 540
        }

        this.model = model;

        this.material = new MeshPhongMaterial({
            opacity: 0,
            transparent: true,
            color: new Color(0x000000),
            blending: NoBlending
        })

        this.mesh = new Mesh(youtubePlaneGeometry, this.material);
        this.mesh.type = 'iframeAgent';
        this.mesh.name = 'iframeAgent';
        this.name = 'iframeAgent';

        // POSTER - placeholder for iframe (no thumbnail like YouTube)
        const wrapDiv = document.createElement('div');
        wrapDiv.setAttribute('class', 'iframe_poster_wrapper');
        const posterContent = document.createElement('div');
        posterContent.setAttribute('class', 'iframe_poster');
        posterContent.innerHTML = '<span class="material-icons-outlined">web</span><span>' + ($trans('iframe-text') || 'iFrame') + '</span>';
        wrapDiv.appendChild(posterContent);

        this.iframe_poster = new CSS3DObject(wrapDiv);
        this.iframe_poster.type = 'iframe_poster';
        this.iframe_poster.name = 'iframe_poster';

        // INIT
        this.camera !== null ? this._setInitialPosRot() : this.setPosition(x, y, z);

        this.add(this.mesh);
        this.add(this.iframe_poster);

        this.mesh.groupDetails = { title: $trans('iframe-text') || 'iFrame', icon: 'web', editTitle: $trans('edit-iframe-agent') || 'Edit iframe', dataLang: 'edit-iframe-agent' }

        this.editControls();

        return this;
    }

    /***
     * @private
     */
    _setInitialPosRot() {
        const position = new Vector3();
        const quaternion = new Quaternion();
        const scale = new Vector3();

        this.camera.matrixWorld.decompose(position, quaternion, scale);
        this.quaternion.copy(quaternion);
        this.position.copy(position);

        this.mesh.translateZ(-540);
        this.iframe_poster.translateZ(-540);
    }

    setId(id) {
        this.unique_id = id;
        this.iframe_poster.element.setAttribute('data-id', `iframe_${this.unique_id}`);
    }

    setIframeValue(value) {
        this.iframe_value = value || '';
    }

    getIframeValue() {
        return this.iframe_value;
    }

    _applyIframeDimensionPreview() {
        const poster = this.iframe_poster?.element?.querySelector?.('.iframe_poster')
            || this.iframe_poster?.element?.firstElementChild;
        if (!poster?.style) return;
        const cfg = this.dbConfig || {};
        poster.style.width = (cfg.iframe_width_enabled && cfg.iframe_width) ? String(cfg.iframe_width) : '';
        poster.style.height = (cfg.iframe_height_enabled && cfg.iframe_height) ? String(cfg.iframe_height) : '';
    }

    setDbConfig(config) {
        super.setDbConfig(config);
        if (
            config?.iframe_width_enabled !== undefined
            || config?.iframe_width !== undefined
            || config?.iframe_height_enabled !== undefined
            || config?.iframe_height !== undefined
        ) {
            this._applyIframeDimensionPreview();
            this.updatePoster?.();
        }
    }

    updatePoster() {
        this.iframe_poster.position.copy(this.mesh.position);
        this.iframe_poster.quaternion.copy(this.mesh.quaternion);
        this.iframe_poster.rotation.copy(this.mesh.rotation);
        this.iframe_poster.scale.copy(this.mesh.scale);
    }

    toggleSelect() {
        this.iframe_poster.element.childNodes[0].classList.toggle('active');
    }

    setAxisRotations(axis, angle) {
        super.setAxisRotations(axis, angle);
        this.updatePoster();
    }

}

export { VRIframeAgentGhost };
